// jQuery Helper
import './scripts/jqueryLib';

// General Scripts
import general from './scripts/general';

document.addEventListener('DOMContentLoaded', function() {
    general();
});